/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    R002: THREE.Mesh;
  };
  materials: {
    [".R.001"]: THREE.MeshStandardMaterial;
  };
};

export function RegisterModel(
  props: React.ComponentProps<"group"> & {
    color?: string;
    metalness?: number;
    roughness?: number;
  }
) {
  const { color, metalness, roughness, ...groupProps } = props;
  const { nodes, materials } = useGLTF(
    "/models/REGISTER.glb"
  ) as unknown as GLTFResult;

  return (
    <group {...groupProps} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.R002.geometry}
        position={[0.5, 0.0, 0.45]}
        rotation={[2.67, -0.5, -3.1]}
        scale={[132.439, 132.439, 132.439]}
      >
        <meshStandardMaterial
          color={color || materials[".R.001"].color}
          metalness={
            metalness !== undefined ? metalness : materials[".R.001"].metalness
          }
          roughness={
            roughness !== undefined ? roughness : materials[".R.001"].roughness
          }
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("/models/REGISTER.glb");
